import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import 'mdb-vue-ui-kit/css/mdb.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../src/style.scss';
import "vuestic-ui/css";
import "vuestic-ui/dist/vuestic-ui.css"; 

import { MDBBtn, MDBInput, MDBModal, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter, MDBModalDialog, MDBTextarea, MDBToast} from 'mdb-vue-ui-kit';
// import { VaSelect } from "vuestic-ui";
import { createVuestic } from "vuestic-ui";
import { environment } from './environment/environment';	


import ModalComponent from './utils/modal.vue';
import CreateFormComponent from './utils/createForm.vue';
import ToastComponent from './utils/toast.vue';
import TimezonesList from 'moment-timezone';

import FieldBeat from '@fieldbeat/javascript';

const app = createApp(App);
const fbInstance = new FieldBeat(environment.name);

app.component('MDBBtn', MDBBtn);
app.component('MDBInput', MDBInput);
app.component('MDBTextarea', MDBTextarea);
app.component('MDBModal', MDBModal);
app.component('MDBModalHeader', MDBModalHeader);
app.component('MDBModalTitle', MDBModalTitle);
app.component('MDBModalBody', MDBModalBody);
app.component('MDBModalFooter', MDBModalFooter);
app.component('MDBModalDialog', MDBModalDialog);
app.component('ModalComponent', ModalComponent);
app.component('CreateFormComponent', CreateFormComponent);
app.component('timezones-list', TimezonesList);
app.component('ToastComponent', ToastComponent);
app.component('MDBToast', MDBToast);
// app.component('VaSelect', VaSelect );

app.config.compilerOptions.isCustomElement = (tag) => tag.startsWith('mdb-');
console.log('[ENVIRONMENT]', environment.name); // Debe decir 'production'
console.log('[NODE_ENV]', process.env.NODE_ENV); // Debe decir 'production'


app.config.globalProperties.$fieldbeat = fbInstance;

app.use(createVuestic());
app.use(router);
app.mount('#app');
